import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AssignmentPvbComponent } from './assignment-pvb/assignment-pvb/assignment-pvb.component';
import { AssignmentPvbModule } from './assignment-pvb/assignment-pvb.module';
import { AdministrationComponent } from './assignment-pvb/administration/administration.component';
import { InternshipAssignmentComponent } from './assignment-pvb/internship-assignment/internship-assignment.component';
import { SigningComponent } from './assignment-pvb/signing/signing.component';
import { CompanySigningComponent } from './assignment-pvb/company-signing/company-signing.component';
import { StudentSigningComponent } from './assignment-pvb/student-signing/student-signing.component';
// tslint:disable-next-line:max-line-length
import { ExaminationCommitteeSigningComponent } from './assignment-pvb/examination-committee-signing/examination-committee-signing.component';
import { DeterminationAssignmentPvbComponent } from './determination-assignment-pvb/determination-assignment-pvb.component';
// tslint:disable-next-line:max-line-length
import { AdministrationComponent as DeterminationAssignmentAdministration } from './determination-assignment-pvb/administration/administration.component';
import { AssignmentComponent as DeterminationAssignmentAssignment } from './determination-assignment-pvb/assignment/assignment.component'
import { SigningComponent as DeterminationAssignmentSigning } from './determination-assignment-pvb/signing/signing.component';
import { DeterminationAssignmentPvbModule } from './determination-assignment-pvb/determination-assignment-pvb.module';

const routes: Routes = [
  {
    path: 'examination-preparation/:studentId/:creboId/determination-assignment-pvb/:formCode',
    component: DeterminationAssignmentPvbComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'administration'
      },
      {
        path: 'administration',
        component: DeterminationAssignmentAdministration
      },
      {
        path: 'assignment',
        component: DeterminationAssignmentAssignment
      }, {
        path: 'signing',
        component: DeterminationAssignmentSigning
      }
    ]
  },
  {
    path: 'examination-preparation/:studentId/:creboId/assignment-pvb/:formCode',
    component: AssignmentPvbComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'administration'
      },
      {
        path: 'administration',
        component: AdministrationComponent
      },
      {
        path: 'assignment',
        component: InternshipAssignmentComponent
      },
      {
        path: 'signing',
        component: SigningComponent,
        children: [
          {
            path: '',
            redirectTo: 'company',
            pathMatch: 'full'
          },
          {
            path: 'company',
            component: CompanySigningComponent
          },
          {
            path: 'company/:batch',
            component: CompanySigningComponent
          },
          {
            path: 'student',
            component: StudentSigningComponent
          },
          {
            path: 'examination-committee',
            component: ExaminationCommitteeSigningComponent
          }
        ]
      }
    ]
  }];

@NgModule({
  imports: [RouterModule.forChild(routes), AssignmentPvbModule, DeterminationAssignmentPvbModule],
  exports: [RouterModule]
})
export class ExamPreparationRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/exam-preparation/exam-preparation-routing.module.ts